export default __webpack_public_path__ + "static/illu_support-be416630944a434681632a84e72aa3a4.png";